<template>
  <form class="form" @submit.prevent="sumbitForm">
    <div class="form-item">
      <label> 收件人</label> <input type="text" v-model="user.name" />
    </div>
    <div class="form-item">
      <label> 手机号码</label><input type="number" v-model="user.tel" />
    </div>
    <div class="form-item">
      <label> 收货地址</label><textarea type="text" @click="isShow = true" v-model="area" readOnly="ture" cols="3">
      </textarea>
    </div>
    <div class="form-item">
      <label>详细地址 </label><textarea cols="3" type="text" v-model="user.address"> </textarea>
    </div>
    <div class="defaultAddr">
      <label>设为默认地址 </label>
      <van-checkbox shape="square" v-model="user.is_default" checked-color="#FF6161"></van-checkbox>
    </div>
    <div class="sumbit">
      <button type="submit">确定</button>
    </div>

    <van-popup v-model="isShow" position="bottom" closeable :style="{ height: '75%' }" :close-on-click-overlay="false">
      <selectArea :info="user" v-if="isShow" @getAreaInfo="getAreaInfo"></selectArea>
    </van-popup>
  </form>
</template>
<script>
import selectArea from "@/components/selectArea"
import { Checkbox, Popup } from "vant";

import { getAddressInfo, addaddress, editaddress } from '@/api/address'

const aLevel = {
  province: 1,
  city: 2,
  county: 3,
  town: 4
}

export default {
  components: {
    [Checkbox.name]: Checkbox,
    [Popup.name]: Popup,
    selectArea
  },
  data () {
    return {
      user: {
        name: '',
        tel: '',
        address: '',
        townId: '',
        countyId: '',
        cityId: '',
        provinceId: '',
        townName: '',
        countyName: '',
        cityName: '',
        provinceName: '',
        address_id: '',
        is_default: ''
      },
      isShow: false
    }
  },
  computed: {
    area () {
      const { provinceName, cityName, countyName, townName } = this.user
      return `${provinceName} ${cityName} ${countyName} ${townName}`
    }
  },
  methods: {
    getAreaInfo (value) {
      for (const key in value) {
        this.user[key] = value[key]
      }
      this.isShow = false
    },
    // 提交表单
    sumbitForm (e) {
      e.preventDefault()
      const rType = this.$route.query.type
      this.user.is_default = Number(this.user.is_default)
      if (rType === 'edit') {
        this.typeEditSumbit()
      }
      if (rType === 'add') {
        this.typeAddSumbit()
      }
    },

    async typeEditSumbit () {
      const result = await editaddress(this.user)
      const anchor = this.$route.hash || ''
      this.$toast(result.data.data.message)
      if (result.data.data.status) {
        this.$router.go(-1)
        // this.$router.replace({
        //   name: 'Myaddress',
        //   hash: anchor
        // })
      }
    },
    async typeAddSumbit () {
      const result = await addaddress(this.user)
      const anchor = this.$route.hash || ''
      this.$toast(result.data.data.message)
      if (result.data.data.status) {
        this.$router.go(-1)
        // if( anchor) {
        // this.$router.replace({
        //   name: 'Myaddress',
        //   hash: anchor
        // })
        // }

      }
    },
    // 获取地址信息
    async getAddressInfo (addrId) {
      const result = await getAddressInfo({ address_id: addrId })
      const areaId = ['provinceId', 'townId', 'countyId', 'cityId']
      if (result.data.data.status) {
        for (const key in this.user) {
          if (areaId.indexOf(key) !== -1) {
            const length = key.length
            this.user[key] = result.data.data.addressInfo[key.substring(0, length - 2)]
          } else {
            this.user[key] = result.data.data.addressInfo[key]
          }
        }
      }

    }
  },
  created () {
    const query = this.$route.query
    if (query.type === 'edit') {
      this.getAddressInfo(query.adid)
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
  // background: #fff;
  color: #333333;
  font-size: 0.32rem;
  margin-top: 2rem;
  padding: 0 0.2rem;
  .form-item {
    width: 95%;
    margin: 0.3rem auto;
    padding: 0.3rem 0;
    border-bottom: 1px solid #e4e4e4;
    display: flex;
  }
  .defaultAddr {
    width: 95%;
    display: flex;
    justify-content: end;
    label {
      width: 2rem;
      margin-right: 0.1rem;
    }
  }
  .sumbit {
    margin-top: 0.9rem;
    text-align: center;
    button {
      background: #ff6161;
      color: #fff;
      border: 0px;
      width: 2.58rem;
      height: 0.72rem;
      line-height: 0.72rem;
      border-radius: 30px;
    }
  }
  label {
    display: inline-block;
    width: 1.5rem;
    // margin: 0.3rem 0;
  }
  input {
    margin-left: 0.3rem;
    height: 0.5rem;
    width: 5rem;
    display: inline-block;
    overflow: visible;
    word-break: break-all;
    border: 0px;
    background: none;
  }
  textarea {
    margin-left: 0.3rem;
    height: 1rem;
    width: 5rem;
    display: inline-block;
    overflow: visible;
    word-break: break-all;
    border: 0px;
    background: none;
    resize: none;
  }
}
</style>